import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { Search, ChevronDown } from "lucide-react";
import SearchSuggestions from "./SearchSuggestions";
import authService from '../../../Services/authService';
import { useCart } from "../../../Services/CartContext";
import { useNavigate } from "react-router-dom";

export default function Header() {
  const { cartCount, fetchCartCount } = useCart();
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const searchRef = useRef(null);
  const location = useLocation();
  const pathname = location.pathname;
  const [showDropdown, setShowDropdown] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const dropdownRef = useRef();
  // useEffect(() => {
  //   const checkLoginStatus = () => {
  //     const isAuthenticated = authService.getCurrentuser() ? true : false;
  //     setIsLoggedIn(isAuthenticated);

  //     if (isAuthenticated) {
  //       fetchCartCount(); // Fetch the cart count if user is logged in
  //     }
  //   };

  //   checkLoginStatus();
  // }, [fetchCartCount]);

  useEffect(() => {
    const isAuthenticated = authService.getCurrentuser() ? true : false;
    setIsLoggedIn(isAuthenticated);

    if (isAuthenticated) {
      fetchCartCount();
    }
  }, []); // Removed fetchCartCount from dependencies

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSearchFocus = () => {
    setShowSuggestions(true);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setShowSuggestions(true);
  };

  const handleSelectSuggestion = () => {
    setShowSuggestions(false);
    setMobileMenuOpen(false);
    setSearchQuery("");
  };


  const handleLogout = () => {
    authService.clientlogout();  // Clear the session from auth service
    //window.location.href = "/login";  // Redirect to login page or another route
    navigate("/login");
  }

  const handleDropdownItemClick = () => {
    setShowDropdown(false);
  };


  return (
    <header className="sticky top-0 z-50 bg-[rgba(245,245,247,0.8)] backdrop-blur-md border-b border-[#E0E0E0]">
      <div className="max-w-6xl mx-auto relative">
        <div className="flex items-center justify-between h-16 px-4 md:px-6">
          <div className="flex items-center space-x-2">
            <Link to="/" className="flex items-center">
              <img src="/images/pranaam-365-logo.png" alt="Pranaam 365 Logo" className="h-12 w-auto" />
            </Link>
          </div>

          <div className="flex-1 max-w-xl mx-4 hidden md:block" ref={searchRef}>
            <div className="relative w-full">
              <div className="relative flex items-center border border-[#E0E0E0] rounded-lg overflow-hidden bg-white">
                {/* <div className="flex items-center border-r border-[#E0E0E0] px-3 py-2 cursor-pointer hover:bg-[#F5F5F7]">
                  <span className="text-sm text-[#4A4A4A]">Check pincode</span>
                  <ChevronDown size={16} className="ml-1 text-[#4A4A4A]" />
                </div> */}
                <div className="flex-1 flex items-center">
                  <Search size={18} className="ml-3 text-[#4A4A4A]/50" />
                  <input
                    type="text"
                    placeholder="Search Tests, Packages"
                    className="w-full px-2 py-2 focus:outline-none text-[#4A4A4A]"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    onFocus={handleSearchFocus}
                  />
                </div>
              </div>
              {showSuggestions && (
                <SearchSuggestions searchQuery={searchQuery} onSelectSuggestion={handleSelectSuggestion} />
              )}
            </div>
          </div>

          <div className="md:hidden flex-1 flex justify-end mr-2">
            <button
              className="p-2 text-[#4A4A4A] hover:text-[#951C25] mobile-search"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <Search size={20} className="justify-end"/>
            </button>
          </div>


          <div className="flex items-center space-x-4">
            {isLoggedIn ? (
              <>
                {cartCount > 0 ? (
                  <Link to="/cart" className="relative p-1.5 text-[#4A4A4A] hover:text-[#951C25]">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle cx="8" cy="21" r="1"></circle>
                      <circle cx="19" cy="21" r="1"></circle>
                      <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path>
                    </svg>
                    <span className="absolute -top-1 -right-1 bg-[#951C25] text-white text-xs w-4 h-4 flex items-center justify-center rounded-full">
                      {cartCount}
                    </span>
                  </Link>
                ) : (
                  <div className="relative p-1.5 text-[#4A4A4A]">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle cx="8" cy="21" r="1"></circle>
                      <circle cx="19" cy="21" r="1"></circle>
                      <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path>
                    </svg>
                    <span className="absolute -top-1 -right-1 bg-[#951C25] text-white text-xs w-4 h-4 flex items-center justify-center rounded-full">
                      {cartCount}
                    </span>
                  </div>
                )}


                <div className="relative" ref={dropdownRef}>
                  <button className="p-1.5 text-[#4A4A4A] hover:text-[#951C25] flex items-center" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  </button>


                  {isDropdownOpen && (
                    <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-[#E0E0E0] z-50">
                      <div className="py-1">
                        <Link to="/profile" onClick={() => setIsDropdownOpen(false)} className="block px-4 py-2 text-sm text-[#4A4A4A] hover:bg-[#F5F5F7] hover:text-[#951C25]">Profile</Link>
                        <Link to="/reports/health-reports" onClick={() => setIsDropdownOpen(false)} className="block px-4 py-2 text-sm text-[#4A4A4A] hover:bg-[#F5F5F7] hover:text-[#951C25]">My Reports</Link>
                        <Link to="/orders" onClick={() => setIsDropdownOpen(false)} className="block px-4 py-2 text-sm text-[#4A4A4A] hover:bg-[#F5F5F7] hover:text-[#951C25]">My Orders</Link>
                        <Link to="/coupons" onClick={() => setIsDropdownOpen(false)} className="block px-4 py-2 text-sm text-[#4A4A4A] hover:bg-[#F5F5F7] hover:text-[#951C25]">Offers</Link>
                        <Link to="/address" onClick={() => setIsDropdownOpen(false)} className="block px-4 py-2 text-sm text-[#4A4A4A] hover:bg-[#F5F5F7] hover:text-[#951C25]">Address</Link>
                        <Link to="/member-details" onClick={() => setIsDropdownOpen(false)} className="block px-4 py-2 text-sm text-[#4A4A4A] hover:bg-[#F5F5F7] hover:text-[#951C25]">Family Members Details</Link>
                        <div className="border-t border-[#E0E0E0] my-1"></div>
                        <button
                          onClick={() => {
                            handleLogout();
                            setIsDropdownOpen(false);
                          }}
                          className="block w-full text-left px-4 py-2 text-sm text-[#951C25] hover:bg-[#F5F5F7]"
                        >
                          Logout
                        </button>
                      </div>
                    </div>
                  )}
                </div>

              </>
            ) : (
              <Link
                to="/login"
                className={`text-base font-medium ${pathname === "/login" ? "text-[#951C25]/80" : "text-[#951C25] hover:text-[#951C25]/80"}`}
              >
                Login
              </Link>
            )}
          </div>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden absolute top-16 left-0 right-0 bg-white border-b border-[#E0E0E0] z-50">
          <div className="p-4" ref={searchRef}>
            <div className="relative w-full">
              <div className="relative flex items-center border border-[#E0E0E0] rounded-lg overflow-hidden bg-white">
                {/* <div className="flex items-center border-r border-[#E0E0E0] px-3 py-2 cursor-pointer hover:bg-[#F5F5F7]">
                  <span className="text-sm text-[#4A4A4A]">Check pincode</span>
                  <ChevronDown size={16} className="ml-1 text-[#4A4A4A]" />
                </div> */}
                <div className="flex-1 flex items-center">
                  <Search size={18} className="ml-3 text-[#4A4A4A]/50" />
                  <input
                    type="text"
                    placeholder="Search Tests, Packages"
                    className="w-full px-2 py-2 focus:outline-none text-[#4A4A4A]"
                    autoFocus
                    value={searchQuery}
                    onChange={handleSearchChange}
                    onFocus={handleSearchFocus}
                  />
                </div>
              </div>
              {showSuggestions && (
                <SearchSuggestions
                  searchQuery={searchQuery}
                  onSelectSuggestion={handleSelectSuggestion}
                  className="max-h-60"
                />
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
